var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    fill: "#FFC71E",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 38.3946C66.8146 38.4004 70.9508 40.1106 74.0017 43.1501C77.0526 46.1896 78.7692 50.3103 78.7751 54.6088V72.3912C78.7707 76.6901 77.0546 80.8117 74.0034 83.8515C70.9521 86.8913 66.8151 88.601 62.5 88.6054C58.1849 88.601 54.0479 86.8913 50.9967 83.8515C47.9454 80.8117 46.2293 76.6901 46.2249 72.3912V54.6088C46.2293 50.3099 47.9454 46.1883 50.9967 43.1485C54.0479 40.1087 58.1849 38.399 62.5 38.3946ZM62.5 36.178C57.594 36.1794 52.8893 38.1217 49.4202 41.5778C45.9511 45.034 44.0015 49.7211 44 54.6088V72.3912C44 77.2794 45.9491 81.9673 49.4186 85.4238C52.888 88.8802 57.5935 90.822 62.5 90.822C67.4065 90.822 72.1121 88.8802 75.5815 85.4238C79.0509 81.9673 81 77.2794 81 72.3912V54.6088C80.9985 49.7211 79.049 45.034 75.5799 41.5778C72.1108 38.1217 67.4061 36.1794 62.5 36.178Z",
    fill: "#FFC71E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5542 27.7218L62.4669 21.8312L68.374 27.7218",
    stroke: "#FFC71E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.374 99.2783L62.4669 105.169L56.5542 99.2783",
    stroke: "#FFC71E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5001 47.3329C62.1299 47.3329 61.7748 47.4794 61.513 47.7402C61.2511 48.0011 61.104 48.3549 61.104 48.7238V56.2047C61.104 56.5736 61.2511 56.9274 61.513 57.1882C61.7748 57.449 62.1299 57.5956 62.5001 57.5956C62.8704 57.5956 63.2256 57.449 63.4874 57.1882C63.7492 56.9274 63.8963 56.5736 63.8963 56.2047V48.7238C63.8963 48.3549 63.7492 48.0011 63.4874 47.7402C63.2256 47.4794 62.8704 47.3329 62.5001 47.3329Z",
    fill: "#FFC71E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.346c1c33e618fdcfaf5ab85e9b75f827.svg";
export { ForwardRef as ReactComponent };